export default __webpack_public_path__ + "static/media/bearshaman_white_icon.b73f8feb.png";